import ServiceCRUD from '../../../services/ServiceCRUDSCALE';

class TimeShiftStatusService extends ServiceCRUD {
  constructor() {
    super('/api/time-shift/status');
  }
}

export default new TimeShiftStatusService();
